/**
 * The host the visitor asked for. useRequestURL reads the request on the
 * server and window.location in the browser, so a server rendered link carries
 * the same utm_source the hydrating browser computes. Outside a Nuxt instance,
 * a click handler after an await, only the browser can say.
 */
function requestHostname(): string | undefined {
  try {
    return useRequestURL().hostname || undefined
  } catch {
    return typeof window !== 'undefined'
      ? window.location?.hostname || undefined
      : undefined
  }
}

export function getUtmSource(): string {
  // Prefer the actual host for UTM.
  const requestHost = requestHostname()
  if (requestHost) {
    const hostname = requestHost.toLowerCase().replace(/^www\./, '')
    const parts = hostname.split('.')
    // Quartz reports as "discover" on every host it is served from. Visitors
    // load qz.com/discover, and a worker there forwards the request to
    // discover.qz.com, which is the host the server sees, so both have to
    // agree or a rendered page carries one utm_source and the browser another.
    if (parts.includes('qz') || parts.includes('not-qz')) {
      return 'discover'
    }
    if (parts.length >= 2) {
      parts.pop() // Remove the last part (TLD). Assumes it's always '.com'.
      return parts.join('.')
    }

    return hostname
  }

  // Fallback
  const { settings } = useGlobalLayoutSettings()
  const siteDomain = (settings?.siteName ?? '').toLowerCase()

  if (siteDomain === 'onenews' || !siteDomain) return 'onenews'
  if (siteDomain === 'shiftnews') return 'shiftnews'
  return `${siteDomain}.onenews`
}
